import { createBrowserRouter } from 'react-router-dom';
import LandingPage from '@/pages/LandingPage';
import NotFoundPage from '@/pages/NotFoundPage';
import LoginPage from '@/pages/auth/LoginPage';
import RegisterPage from '@/pages/auth/RegisterPage';
import ForgotPasswordPage from '@/pages/auth/ForgotPasswordPage';
import ResetPasswordPage from '@/pages/auth/ResetPasswordPage';
import VerifyEmailPage from '@/pages/auth/VerifyEmailPage';
import OAuthCallbackPage from '@/pages/auth/OAuthCallbackPage';
import DashboardPage from '@/pages/DashboardPage';
import MeetingsPage from '@/pages/MeetingsPage';
import SchedulePage from '@/pages/SchedulePage';
import RecordingsPage from '@/pages/RecordingsPage';
import AnalyticsPage from '@/pages/AnalyticsPage';
import AdminDashboardPage from '@/pages/AdminDashboardPage';
import SettingsPage from '@/pages/SettingsPage';
import PricingPage from '@/pages/PricingPage';
import JoinPage from '@/pages/JoinPage';
import MeetingRoomPage from '@/pages/MeetingRoomPage';
import ProtectedRoute from '@/components/ProtectedRoute';
import DashboardLayout from '@/components/DashboardLayout';

/**
 * Application routes. Recordings, analytics, admin and settings pages are added
 * in their respective phases under the protected layout.
 */
export const router = createBrowserRouter([
  { path: '/', element: <LandingPage /> },
  { path: '/pricing', element: <PricingPage /> },

  // Public auth pages
  { path: '/login', element: <LoginPage /> },
  { path: '/register', element: <RegisterPage /> },
  { path: '/forgot-password', element: <ForgotPasswordPage /> },
  { path: '/reset-password', element: <ResetPasswordPage /> },
  { path: '/verify-email', element: <VerifyEmailPage /> },
  { path: '/oauth/callback', element: <OAuthCallbackPage /> },

  // Public join + meeting room (guests allowed)
  { path: '/join', element: <JoinPage /> },
  { path: '/meeting/:id', element: <MeetingRoomPage /> },

  // Protected app shell
  {
    element: <ProtectedRoute />,
    children: [
      {
        element: <DashboardLayout />,
        children: [
          { path: '/dashboard', element: <DashboardPage /> },
          { path: '/meetings', element: <MeetingsPage /> },
          { path: '/schedule', element: <SchedulePage /> },
          { path: '/recordings', element: <RecordingsPage /> },
          { path: '/analytics', element: <AnalyticsPage /> },
          { path: '/settings', element: <SettingsPage /> },
        ],
      },
    ],
  },

  // Admin-only
  {
    element: <ProtectedRoute roles={['ADMIN', 'SUPER_ADMIN']} />,
    children: [
      {
        element: <DashboardLayout />,
        children: [{ path: '/admin', element: <AdminDashboardPage /> }],
      },
    ],
  },

  { path: '*', element: <NotFoundPage /> },
]);
